export const PLAN_CREDIT_TEXT = {
  ja: {
    pageTitle: 'プラン / クレジット',
    planSectionTitle: 'プラン',
    creditSectionTitle: '追加クレジット',
    storageSectionTitle: '追加ストレージ',
    storageSectionDescription: '何度でも購入でき合算されます。',
    monthlyCredit: '月次Credit',
    grantedCredit: '付与Credit',
    includedFeatures: '利用できる機能',
    selectedPlanLabel: '契約中',
    billingMonthly: '月額',
    billingAnnual: '年額',
    annualSaving: '2か月分お得',
    monthlyEquivalent: '月換算',
    monthlyGrant: 'Creditは毎月付与',
    plans: [
      {
        id: 'free',
        name: 'Free',
        monthlyPrice: '¥0 / 月',
        annualPrice: '¥0 / 年',
        creditValue: '初回 20,000 © / 以後 10,000 ©',
        basicFeature: {
          label: '基本機能',
          columns: [
            {
              title: '用途選択',
              items: ['├レビュー', '├比較', '├検証', '├改善', '├調査', '├計画', '└検討'],
            },
            {
              items: ['目的整理', '前提・不足確認', '事実確認', 'リスク確認', '反対視点の確認', '選択肢の比較', '推奨案の整理'],
            },
          ],
        },
        features: ['Storage：1GB'],
      },
      {
        id: 'basic',
        name: 'Basic',
        monthlyPrice: '¥980 / 月',
        annualPrice: '¥9,800 / 年',
        annualMonthlyEquivalent: '約 ¥817 / 月',
        creditValue: '180,000 ©',
        features: [
          '基本機能',
          '高精度翻訳',
          '書類作成',
          'Private Mode',
          '外部Storage転送',
          'Astera Storage',
          'Storage：5GB',
        ],
      },
      {
        id: 'pro',
        name: 'Pro',
        monthlyPrice: '¥2,980 / 月',
        annualPrice: '¥29,800 / 年',
        annualMonthlyEquivalent: '約 ¥2,483 / 月',
        creditValue: '640,000 ©',
        features: [
          '基本機能',
          '高精度翻訳',
          '書類作成',
          'Private Mode',
          '外部Storage転送',
          'Astera Storage',
          'Astera公式／個別書類テンプレート',
          'API',
          'Storage：20GB',
        ],
      },
      {
        id: 'business',
        name: 'Business',
        monthlyPrice: '¥9,980 / 月',
        annualPrice: '¥99,800 / 年',
        annualMonthlyEquivalent: '約 ¥8,317 / 月',
        creditValue: '2,200,000 ©',
        features: [
          '基本機能',
          '高精度翻訳',
          '書類作成',
          'Private Mode',
          '外部Storage転送',
          'Astera Storage',
          'Astera公式／個別書類テンプレート',
          'API',
          'Storage：50GB',
        ],
      },
      {
        id: 'enterprise',
        name: 'Enterprise',
        monthlyPrice: '¥29,800 / 月',
        annualPrice: '¥298,000 / 年',
        annualMonthlyEquivalent: '約 ¥24,833 / 月',
        creditValue: '6,600,000 ©',
        features: [
          '基本機能',
          '高精度翻訳',
          '書類作成',
          'Private Mode',
          '外部Storage転送',
          'Astera Storage',
          'Astera公式／個別書類テンプレート',
          'API',
          'Storage：150GB',
        ],
      },
    ],
    credits: [
      { name: '©500pack', price: '¥500', creditValue: '75,000 ©' },
      { name: '©1000pack', price: '¥1,000', creditValue: '155,000 ©' },
      { name: '©3000pack', price: '¥3,000', creditValue: '480,000 ©' },
      { name: '©5000pack', price: '¥5,000', creditValue: '815,000 ©' },
      { name: '©10000pack', price: '¥10,000', creditValue: '1,650,000 ©' },
      { name: '©30000pack', price: '¥30,000', creditValue: '5,000,000 ©' },
    ],
    storage: [
      { name: '＋1GB', price: '¥480' },
      { name: '＋10GB', price: '¥1,980' },
      { name: '＋50GB', price: '¥5,980' },
    ],
  },
  en: {
    pageTitle: 'Plan / Credit',
    planSectionTitle: 'Plans',
    creditSectionTitle: 'Additional Credit',
    storageSectionTitle: 'Additional Storage',
    storageSectionDescription: 'Purchase as many times as needed; capacities are combined.',
    monthlyCredit: 'Monthly credit',
    grantedCredit: 'Granted credit',
    includedFeatures: 'Included features',
    selectedPlanLabel: 'Current',
    billingMonthly: 'Monthly',
    billingAnnual: 'Annual',
    annualSaving: '2 months free',
    monthlyEquivalent: 'Monthly equivalent',
    monthlyGrant: 'Credits are granted monthly',
    plans: [
      {
        id: 'free',
        name: 'Free',
        monthlyPrice: '¥0 / month',
        annualPrice: '¥0 / year',
        creditValue: '20,000 © first month / 10,000 © after',
        basicFeature: {
          label: 'Core features',
          columns: [
            {
              title: 'Use cases',
              items: ['├Review', '├Compare', '├Verify', '├Improve', '├Research', '├Plan', '└Consider'],
            },
            {
              items: ['Clarify purpose', 'Check missing context', 'Check facts', 'Check risks', 'Check opposing views', 'Compare options', 'Organize recommendations'],
            },
          ],
        },
        features: ['Storage: 1GB'],
      },
      {
        id: 'basic',
        name: 'Basic',
        monthlyPrice: '¥980 / month',
        annualPrice: '¥9,800 / year',
        annualMonthlyEquivalent: 'About ¥817 / month',
        creditValue: '180,000 ©',
        features: [
          'Core features',
          'High-accuracy translation',
          'Document creation',
          'Private Mode',
          'External storage transfer',
          'Astera Storage',
          'Storage: 5GB',
        ],
      },
      {
        id: 'pro',
        name: 'Pro',
        monthlyPrice: '¥2,980 / month',
        annualPrice: '¥29,800 / year',
        annualMonthlyEquivalent: 'About ¥2,483 / month',
        creditValue: '640,000 ©',
        features: [
          'Core features',
          'High-accuracy translation',
          'Document creation',
          'Private Mode',
          'External storage transfer',
          'Astera Storage',
          'Astera official / custom document templates',
          'API',
          'Storage: 20GB',
        ],
      },
      {
        id: 'business',
        name: 'Business',
        monthlyPrice: '¥9,980 / month',
        annualPrice: '¥99,800 / year',
        annualMonthlyEquivalent: 'About ¥8,317 / month',
        creditValue: '2,200,000 ©',
        features: [
          'Core features',
          'High-accuracy translation',
          'Document creation',
          'Private Mode',
          'External storage transfer',
          'Astera Storage',
          'Astera official / custom document templates',
          'API',
          'Storage: 50GB',
        ],
      },
      {
        id: 'enterprise',
        name: 'Enterprise',
        monthlyPrice: '¥29,800 / month',
        annualPrice: '¥298,000 / year',
        annualMonthlyEquivalent: 'About ¥24,833 / month',
        creditValue: '6,600,000 ©',
        features: [
          'Core features',
          'High-accuracy translation',
          'Document creation',
          'Private Mode',
          'External storage transfer',
          'Astera Storage',
          'Astera official / custom document templates',
          'API',
          'Storage: 150GB',
        ],
      },
    ],
    credits: [
      { name: '©500pack', price: '¥500', creditValue: '75,000 ©' },
      { name: '©1000pack', price: '¥1,000', creditValue: '155,000 ©' },
      { name: '©3000pack', price: '¥3,000', creditValue: '480,000 ©' },
      { name: '©5000pack', price: '¥5,000', creditValue: '815,000 ©' },
      { name: '©10000pack', price: '¥10,000', creditValue: '1,650,000 ©' },
      { name: '©30000pack', price: '¥30,000', creditValue: '5,000,000 ©' },
    ],
    storage: [
      { name: '+1GB', price: '¥480' },
      { name: '+10GB', price: '¥1,980' },
      { name: '+50GB', price: '¥5,980' },
    ],
  },
} as const;